import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectEditBillingShiftDifferentialRows,
  selectEditPayrollShiftDifferentialRows,
  selectIsEditMod,
  selectShiftDifferentialTypeError,
  selectShiftDifferentialTypes,
} from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { Controller, useFormContext } from 'react-hook-form';
import { FormInputDropdown } from '@AMIEWEB/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { makeStyles } from 'tss-react/mui';
import { findIndex, findRow } from '../Utils';
import { modsEnums } from 'app/models/Placement/PlacementMods';

const useStyles = makeStyles()(() => ({
  inputFields: {
    '& .MuiInputBase-input.MuiFilledInput-input': {
      paddingTop: '10px',
    },
  },
}));

interface GridCellProps {
  [key: string]: any;
}

export const EditTypeCell = (props: any) => {
  return <EditType cellParams={props?.cellParams} currentMod={props?.currentMod} />;
};

const EditType = React.memo(function EditType(params: GridCellProps) {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const [shiftDifferentialType, setShiftDifferentialType] = useState(params?.cellParams?.row?.shiftDifferentialType);
  const { control } = useFormContext();
  const isModEdit = useSelector(selectIsEditMod);
  const options = useSelector(selectShiftDifferentialTypes);

  const rowId = params?.cellParams?.id;
  //@Team : @Lakshmi - Please remove the use selectors to be used conditionally
  const shiftDiffEditRequests =
    params?.currentMod === modsEnums.PayrollShiftDifferential
      ? useSelector(selectEditPayrollShiftDifferentialRows)
      : useSelector(selectEditBillingShiftDifferentialRows);
  const typeErrors = useSelector(selectShiftDifferentialTypeError);

  useEffect(() => {
    if (params?.cellParams?.error !== null && params?.cellParams?.error !== undefined) {
      const val = typeErrors?.filter(el => el.id === params?.cellParams?.id);

      const arr = typeErrors?.length > 0 ? typeErrors?.slice(0) : [];
      if (val?.length === 0) {
        const valueObj = { type: params?.cellParams?.error, id: params?.cellParams?.id };

        arr.push(valueObj);
      } else {
        const currentObj = arr.find(val => val.id === params?.cellParams?.id);
        const updatedObj = { ...currentObj, type: params?.cellParams?.error };
        const editIndex = arr.findIndex(val => val.id === params?.cellParams?.id);

        arr[editIndex] = updatedObj;
      }

      dispatch(placementModsAction.setShiftDifferentialTypeError(arr));
    }
  }, [params?.cellParams?.error]);

  const setTypeForEdit = data => {
    setShiftDifferentialType(data);
    let newRow = shiftDiffEditRequests.slice(0);
    const shiftDiffEditRow = findRow(params, shiftDiffEditRequests, rowId);
    const updatedCell = {
      ...shiftDiffEditRow,
      shiftDifferentialType: data,
      shiftDifferentialTypeId: parseInt(options.find(el => el.Description === data)?.ID),
    };

    const editDateIndex = findIndex(updatedCell, params, shiftDiffEditRequests, rowId);
    newRow[editDateIndex] = updatedCell;
    switch (params?.currentMod) {
      case modsEnums.PayrollShiftDifferential: {
        dispatch(placementModsAction.setEditPayrollShiftDiffRows(newRow));
        break;
      }
      case modsEnums.BillingShiftDifferential: {
        dispatch(placementModsAction.setEditBillingShiftDiffRows(newRow));
        break;
      }
    }
  };

  return (
    <>
      <Controller
        name={`shiftDiffRequests${rowId}.types`}
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value, ...rest } }) => (
          <FormInputDropdown
            customClass={classes.inputFields}
            name={'shiftDiffRequests.shiftDifferentialType'}
            require={true}
            standard={true}
            options={options ?? []}
            inputValue={shiftDifferentialType ?? null}
            readOnly={!isModEdit}
            handleChange={e => {
              setTypeForEdit(e.target.value);
              dispatch(placementModsAction.setCustomTemplateType(true));
              dispatch(placementModsAction.setOriginCustomTemplateChanged(true));
            }}
          ></FormInputDropdown>
        )}
      />
    </>
  );
});
